import Vue from "vue";
import Router from "vue-router";
//import Main from "@/components/Main";
import LoginPage from "@/components/Auth/Login";
import RegisterPage from "@/components/Auth/Register";
import ProfilePage from "@/components/Profile/Profile";
import RememberPage from "@/components/Auth/Remember";
import ChangePage from "@/components/Auth/ChangePage";
import ServicePage from "@/components/Serwisowy"

import ContentPage from "@/components/Content";
import PriceListPage from "@/components/PriceListPage";

Vue.use(Router);

export default new Router({
  //mode: "history",
  //hash: false,
  routes: [
    {
      path: "/",
      name: "PriceListPage",
      component: PriceListPage
    },
    {
      path: "/content",
      name: "ContentPage",
      component: ContentPage
    },
    {
      path: "/login",
      name: "LoginPage",
      component: LoginPage
    },
    {
      path: "/signup",
      name: "RegisterPage",
      component: RegisterPage
    },
    {
      path: "/profile",
      name: "ProfilePage",
      component: ProfilePage
    },
    {
      path: "/remember",
      name: "RememberPage",
      component: RememberPage
    },
    {
      path: "/change/:token",
      name: "ChangePage",
      component: ChangePage
    },
    {
      path: "/service",
      name: "ServicePage",
      component: ServicePage
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js